import { render } from "./SimsStatsSection.vue?vue&type=template&id=3bf4d71e"
import script from "./SimsStatsSection.vue?vue&type=script&lang=js"
export * from "./SimsStatsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__